import { type HttpGet, buildQueryString } from '@/shared/infra/http'
import type { Todo } from '@/shared/domain/todo'
import type { ListItemTodos } from '@/shared/domain/use-cases'

type ListItemTodosResponse = { todos: Todo[]; total: number }

export class EdgeListItemTodosRepository {
  constructor(private readonly http: HttpGet) {}

  execute: ListItemTodos = async ({ orgId, orgType, equipmentItemId }) => {
    const response = await this.http.get<ListItemTodosResponse>({
      url: `/todos${buildQueryString({ orgId, orgType, equipmentItemId, limit: 50, offset: 0 })}`,
    })
    return response.todos
  }
}
